import React, { useContext, useEffect, useState } from 'react';
import { Loan, Task, TaskResponse, TaskState } from 'gql/graphql';
import { CardLoanTasksProps } from 'components/Atoms/Cards/CardLoanTasks/CardLoanTasks';
import TrackRecord from './TrackRecord';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import CircleTag from '../../../../../components/Atoms/Tags/CircleTag/CircleTag';

interface Props {
  tasks?: Task[] | any[],
  loan: Loan | any
}

const useCardTrackRecord = ({ tasks, loan }: Props) => {
  const [dataTask, setDataTask] = useState<Task>();
  const [stepNow, setStepNow] = useState<TaskResponse>();
  const [response, setResponse] = useState<TaskResponse>();

  useEffect(() => {
    if (tasks) {
      const data: Task = tasks.find((item) => item.key === ModuleKeys.TRACK_RECORD);
      setDataTask(data);
      setResponse(data?.responses.find(item => item.key !== 'doc-another'));

      if (data?.responses.length > 0)
        setStepNow(data?.responses.reduce((max, obj) => obj.step > max.step ? obj : max, data?.responses[0]));
    }
  }, [tasks]);

  const getFilesCircle = () => {
    const filesWithoutError = response?.files?.filter((item: any) => item.state !== 'request_error') || [];
    
    if (filesWithoutError.length > 0) {
      return [filesWithoutError[filesWithoutError.length - 1]];
    }
    
    const lastFile = response?.files?.slice(-1)[0];
    return lastFile ? [lastFile] : [{ state: 'DRAFT' }];
  };

  const getTotalApproved = () => {
    const filesWithoutError = response?.files?.filter((item: any) => item.state !== 'request_error') || [];
    return filesWithoutError.length > 0 ? 1 : 0;
  };

  const card: CardLoanTasksProps =
  {
    key: ModuleKeys.TRACK_RECORD,
    title: <h4 className="h4">Past Investment Experience</h4>,
    type: 'quick task',
    steps: 1,
    stepCurrent: stepNow?.step || 0,
    state: dataTask?.state,
    actions: dataTask ? [<TrackRecord key={1} task={dataTask} />] : [],
    text: (
      <p className="body-card">
        I’ve purchased/sold{' '}
        <span className="body-card-bold-line">
          {loan?.investmentExperience?.properties === 'none' ? 'no' : loan?.investmentExperience?.properties}
        </span>
        {' '}real estate properties in the past 36 months
      </p>
    ),
    text2: (
      <div className='docs-section'>
        <div className='labels'>
          <p className={`body-regular body-regular-bold`}>
            Document status
          </p>
          <p className={`body-card`}>
            {getTotalApproved()}/1 submitted
          </p>
        </div>
        <div className={`circles-tags`}>
          {getFilesCircle().map((_response, index) => {
            let _state = _response?.state?.toUpperCase() || 'DRAFT';
            
            return (<CircleTag
              key={index}
              state={_state}
              tagKey={_state}
              isIconState={true}
            />);
          })}
        </div>
      </div>
    )
    
  };

  if(!dataTask) 
    return { card: null };
  
  return {
    card,
    dataTask
  };
};

export default useCardTrackRecord;
